import { createSlice } from '@reduxjs/toolkit'

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    selectedSection: 'Profile',
    user: null,
    topics: [],
    permissions: null
  },
  reducers: {
    setSelectedSection(state, action) {
      state.selectedSection = action.payload
    },
    setUser(state, action) {
      state.user = action.payload
    },
    setTopics(state, action) {
      state.topics = action.payload
    },
    setPermissions(state, action) {
      state.permissions = action.payload
    }
  }
})

export const { setSelectedSection, setUser, setTopics, setPermissions } = dashboardSlice.actions
export default dashboardSlice.reducer
